/*
 * @Author: Teemo Ding
 * @Date: 2022-04-26 16:45:05
 * @LastEditTime: 2022-07-06 16:21:24
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportingDashboard/index.tsx
 */
import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import {
  isUserValid,
  isUserValidOr,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { thousandsSeparator as formatPrice } from '@/src/tools/helper';
import { analyticsDashboardPage } from '@/src/tools/permissions/storePermissions';
import { IDateRange } from '@/src/types/common/report';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import {
  Form,
  //Spin, //Input
} from 'antd';
import { get, remove } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import NoPermission from 'src/components/NoPermission';
import { getSalesChannels } from 'src/constrains/GlobalProvider/slice';
import Filter, { EnumFilterType } from 'src/constrains/Query1/Filter';
import Tags from 'src/constrains/Query1/Tags';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { reportDashboardInit } from 'src/request/analytics/reportingDashboard';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { ICategory } from 'src/types/common/report';
import ReportData from '../Components/DateRange';
import BarChartItem from './Components/BarChartItem';
import LineChartItem from './Components/LineChartItem';
import { breadcrumbData } from './config';
import css from './css.module.less';
import { Skeleton } from '@/src/components/Antd';

// // import {
// //   I18nContext,
// //   getCurrentLanguageSet,
// // } from '../../../../locale/IntlProvider/IntlProvider';
// // import { ELang } from 'src/types/common/language';

// // import { errorTest } from 'src/request';
// // import { getAllLanguage } from 'src/request/common';
// //import { ErrorBoundary } from 'src/components/ErrorBoundary';
// const language = JSON.parse(
//   localStorage.getItem('localhost:9000__unifyXP__SYS_LANGUAGE'),
// );

// const nameDict1 = get(General, language);
// const nameDict1 = {
//   aaa:
//     get(
//       get(window, 'portalI18n'),
//       'allOrders.createneworder.component_NoPermission_desc',
//     ) || 'Order',
// };

const access_permission = () => {
  return isUserValidOr({
    source: EPermissionSource.store,
    resourcesGroup: analyticsDashboardPage,
  });
};

const permissions = () => {
  const view_dashboard = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Analytics,
        subCategory: EnumSubCategory.AnalyticsDashboard,
        operation: EnumOperation.view_dashboard,
      }),
    ],
  });
  return {
    view_dashboard,
  };
};

const ReportingDashboard = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const salesChannels = useSelector(getSalesChannels());
  const acc = access_permission();
  const { view_dashboard } = permissions();
  const [form] = Form.useForm();

  const {
    data: {
      currencySymbol = '',
      lineChart: {
        lineChartPoints = [],
        totalOrderCreatedAmount = '',
        totalOrderPaidAmount = '',
        totalOrderCreatedCount = '',
        totalOrderPaidCount = '',
        totalGuestCheckoutOrderAmount = '',
        totalGuestCheckoutOrderCount = '',
        totalNewCustomerOrderAmount = '',
        totalNewCustomerOrderCount = '',
        totalReturningCustomerOrderAmount = '',
        totalReturningCustomerOrderCount = '',
        totalCustomerOrderAmount = '',
        totalCustomerOrderCount = '',
      } = {},
      paidOrderAmountByLogisticsMethod = {},
      topProductsByQuantityOfPurchase = {},
      numberOfPaidOrderByLogisticsMethod = {},
      numberOfPaidOrderBySalesChannel = {},
      topDestinationRegionsByPaidOrderAmount = {},
      paidOrderAmountBySalesChannel = {},
      topDestinationRegionsByNumberOfPaidOrder = {},
      topProductsByPurchaseAmount = {},
      thousandsSeparator = '',
      decimalSeparator = '',
    } = {},
    loading,
    run: _reportDashboardInit,
  } = useRequest(
    (data) =>
      reportDashboardInit({
        dateRange: IDateRange.WeekToDate,
        ...data,
      }),
    {
      ready: !!view_dashboard,
      onSuccess: (res) => {
        const { dateRange, beginDate, endDate } = res || {};
        form.setFieldsValue({
          reportData: {
            dateRange,
            beginDate,
            endDate,
          },
        });
      },
    },
  );

  const filterList = [
    {
      type: EnumFilterType.MultipleSelection,
      dropdownProps: { name: getI18n('general.sider.salesChannel') },
      keyWord: 'salesChannel',
      options: (salesChannels || []).map((item) => ({
        label: item.name,
        value: item.uuid,
      })),
    },
  ];
  const handleValuesChange = () => {
    const { salesChannels: { salesChannel = [] } = {}, reportData } =
      form.getFieldsValue() || {};
    const salesChannelUuids = salesChannel.map((item) => item.value);
    _reportDashboardInit({ salesChannelUuids, ...reportData });
  };

  const handleTagClose = (value) => {
    const { salesChannels: { salesChannel = [] } = {}, reportData } =
      form.getFieldsValue() || {};
    remove(salesChannel, (n: any) => n.value === value.value);
    form.setFieldsValue({ salesChannels: { salesChannel } });

    const salesChannelUuids = salesChannel.map((item) => item.value);
    _reportDashboardInit({ salesChannelUuids, ...reportData });
  };
  const handleFormatPrice = (value: string) => {
    const price = formatPrice(value, thousandsSeparator, decimalSeparator);
    return `${currencySymbol} ${price}`;
  };
  const handleFormatAmount = (value: string) => {
    const text = formatPrice(value, thousandsSeparator, decimalSeparator);
    return text;
  };
  // const errorTest = () => {
  //   const c: any = '';
  //   c.map((i) => i);
  // };
  // const { run: codeRun } = useRequest((code) => errorTest(code), {
  //   manual: true,
  // });
  // const { run: langRun } = useRequest(() => getAllLanguage(), {
  //   manual: true,
  // });
  // const { setLang, lang } = React.useContext(I18nContext);
  // const langSet = getCurrentLanguageSet(lang);
  // const [i, setI] = React.useState('');
  // const [form1] = Form.useForm();

  return acc ? (
    <Skeleton loading={loading} active>
      {/* <button
        onClick={() => {
          setLang(ELang['zh-CN']);
        }}>
        qie cn
      </button>
      <button
        onClick={() => {
          setLang(ELang['en-GB']);
        }}>
        qie en
      </button>
      <button
        onClick={() => {
          console.log(form1.getFieldsValue());
        }}>
        say
      </button>
      title:{langSet['nb']}{' '}
      <Input
        value={i}
        onChange={(e) => {
          setI(e.target.value);
        }}
      />
      <Form form={form1}>
        <Form.Item name='test'>
          <Input />
        </Form.Item>
      </Form> */}
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={breadcrumbData({ getI18n })}
      />

      {/* <div onClick={errorTest}>errorTest</div> */}
      {/* <div
        onClick={() => {
          langRun();
        }}>
        duplicate
      </div>
      <div
        onClick={() => {
          getAllLanguage();
        }}>
        duplicate111
      </div>
      <div
        onClick={() => {
          codeRun(400);
        }}>
        400
      </div>
      <div
        onClick={() => {
          errorTest(400);
        }}>
        400 normal
      </div>
      <div
        onClick={() => {
          codeRun(500);
        }}>
        500
      </div> */}
      <SectionWrapper
        containerClassName={css.sectionContainer}
        titleClassName={css.titleClassNameFirst}
        title={getI18n('general.sider.dashboard')}>
        <Form onValuesChange={handleValuesChange} form={form} name='dashboard'>
          <div className={css.dashboard}>
            <Form.Item name='salesChannels' valuePropName='data'>
              <Filter filters={filterList} />
            </Form.Item>

            <Form.Item name='reportData'>
              <ReportData disabled={!view_dashboard} />
            </Form.Item>
          </div>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) =>
              prevValues.salesChannels !== curValues.salesChannels
            }>
            {({ getFieldValue }: any) => {
              const salesChannels = getFieldValue('salesChannels');

              return (
                get(salesChannels, 'salesChannel.length') > 0 && (
                  <div className={css.tagContainer}>
                    <Tags
                      onClose={handleTagClose}
                      data={get(getFieldValue('salesChannels'), 'salesChannel')}
                      disabled={!view_dashboard}
                    />
                  </div>
                )
              );
            }}
          </Form.Item>
        </Form>
      </SectionWrapper>
      <div className={css.bottom}>
        <LineChartItem
          data={lineChartPoints}
          yAxisTitle={`${getI18n(
            'dashboard.reportingDashboardcommon.orderamount_ytitle',
          )} (${currencySymbol})`}
          title={getI18n('dashboard.reportingDashboardcommon.totalOrderAmount')}
          totalList={{
            [getI18n(
              'dashboard.reportingDashboardcommon.created_lines',
            )]: `${currencySymbol}${totalOrderCreatedAmount}`,
            [getI18n(
              'dashboard.reportingDashboardcommon.paid_lines',
            )]: `${currencySymbol}${totalOrderPaidAmount}`,
          }}
          formatPrice={handleFormatPrice}
          tickFormatter={handleFormatAmount}
          lines={{
            orderCreatedAmount: {
              color: '#00CAFF',
              label: getI18n(
                'dashboard.reportingDashboardcommon.created_lines',
              ),
            },
            orderPaidAmount: {
              color: '#38C568',
              label: getI18n('dashboard.reportingDashboardcommon.paid_lines'),
            },
          }}
          viewReportUrl='/reportList?activeTab=Order'
        />
        <LineChartItem
          data={lineChartPoints}
          yAxisTitle={getI18n(
            'dashboard.reportingDashboardcommon.number_ytitle',
          )}
          title={getI18n(
            'dashboard.reportingDashboardcommon.totalNumberofOrders',
          )}
          totalList={{
            [getI18n('dashboard.reportingDashboardcommon.created_lines')]:
              totalOrderCreatedCount,
            [getI18n('dashboard.reportingDashboardcommon.paid_lines')]:
              totalOrderPaidCount,
          }}
          lines={{
            orderCreatedCount: {
              color: '#00CAFF',
              label: getI18n(
                'dashboard.reportingDashboardcommon.created_lines',
              ),
            },
            orderPaidCount: {
              color: '#38C568',
              label: getI18n('dashboard.reportingDashboardcommon.paid_lines'),
            },
          }}
          viewReportUrl='/reportList?activeTab=Order'
        />
        <LineChartItem
          data={lineChartPoints}
          title={getI18n('dashboard.reportingDashboardcommon.paidorder')}
          totalList={{
            [getI18n(
              'dashboard.reportingDashboardcommon.guest',
            )]: `${currencySymbol}${totalReturningCustomerOrderAmount}`,
            [getI18n(
              'dashboard.reportingDashboardcommon.newCustomer',
            )]: `${currencySymbol}${totalNewCustomerOrderAmount}`,
            [getI18n(
              'dashboard.reportingDashboardcommon.guest',
            )]: `${currencySymbol}${totalGuestCheckoutOrderAmount}`,
            [getI18n(
              'dashboard.reportingDashboardcommon.total',
            )]: `${currencySymbol}${totalCustomerOrderAmount}`,
          }}
          formatPrice={handleFormatPrice}
          tickFormatter={handleFormatAmount}
          yAxisTitle={`${getI18n(
            'dashboard.reportingDashboardcommon.paidorder_amont',
          )} (${currencySymbol})`}
          lines={{
            guestCheckoutOrderAmount: {
              color: '#00CAFF',
              label: getI18n('dashboard.reportingDashboardcommon.guest'),
            },
            newCustomerOrderAmount: {
              color: '#DB00FF',
              label: getI18n('dashboard.reportingDashboardcommon.newCustomer'),
            },
            returningCustomerOrderAmount: {
              color: '#38C568',
              label: getI18n(
                'dashboard.reportingDashboardcommon.returningCustomer',
              ),
            },
          }}
          viewReportUrl='/reportList?activeTab=Order'
        />
        <LineChartItem
          data={lineChartPoints}
          title={getI18n(
            'dashboard.reportingDashboardcommon.number_bycustormer',
          )}
          yAxisTitle={getI18n(
            'dashboard.reportingDashboardcommon.number_ofpaid',
          )}
          totalList={{
            [getI18n('dashboard.reportingDashboardcommon.returningCustomer')]:
              totalReturningCustomerOrderCount,
            [getI18n('dashboard.reportingDashboardcommon.newCustomer')]:
              totalNewCustomerOrderCount,

            [getI18n('dashboard.reportingDashboardcommon.guest')]:
              totalGuestCheckoutOrderCount,
            [getI18n('dashboard.reportingDashboardcommon.total')]:
              totalCustomerOrderCount,
          }}
          lines={{
            guestCheckoutOrderCount: {
              color: '#00CAFF',
              label: getI18n('dashboard.reportingDashboardcommon.guest'),
            },
            newCustomerOrderCount: {
              color: '#DB00FF',
              label: getI18n('dashboard.reportingDashboardcommon.newCustomer'),
            },
            returningCustomerOrderCount: {
              color: '#38C568',
              label: getI18n(
                'dashboard.reportingDashboardcommon.returningCustomer',
              ),
            },
          }}
          viewReportUrl='/reportList?activeTab=Order'
        />
        <BarChartItem
          data={paidOrderAmountBySalesChannel}
          formatAmount={handleFormatAmount}
          title={getI18n('dashboard.reportingDashboardcommon.pbabsc')}
          barTitle={`${getI18n(
            'dashboard.reportingDashboardcommon.guest',
          )} (${currencySymbol})`}
          overlayTitle={getI18n('dashboard.reportingDashboardcommon.pbabsc')}
          overlayDescription={getI18n(
            'dashboard.reportingDashboardcommon.pbabsc_overlaydesc',
          )}
        />
        <BarChartItem
          formatAmount={handleFormatAmount}
          data={numberOfPaidOrderBySalesChannel}
          title={getI18n('dashboard.reportingDashboardcommon.nopobsc_title')}
          barTitle={replaceI18nVariables(
            getI18n('dashboard.reportingDashboardcommon.nopobsc_bartitle'),
            currencySymbol,
          )}
          overlayTitle={getI18n(
            'dashboard.reportingDashboardcommon.nopobsc_title',
          )}
          overlayDescription={getI18n(
            'dashboard.reportingDashboardcommon.nopobsc_overlaydesc',
          )}
        />
        <BarChartItem
          formatAmount={handleFormatAmount}
          data={topProductsByPurchaseAmount}
          viewReportUrl={`/reportList?activeTab=${ICategory.Product}`}
          title={getI18n('dashboard.reportingDashboardcommon.tpbpa_title')}
          barTitle={replaceI18nVariables(
            getI18n('dashboard.reportingDashboardcommon.tpbpa_bartitle'),
            currencySymbol,
          )}
          overlayTitle={getI18n(
            'dashboard.reportingDashboardcommon.tpbpa_overlaytitle',
          )}
          overlayDescription={getI18n(
            'dashboard.reportingDashboardcommon.tpbpa_overlaydesc',
          )}
        />
        <BarChartItem
          formatAmount={handleFormatAmount}
          data={topProductsByQuantityOfPurchase}
          viewReportUrl={`/reportList?activeTab=${ICategory.Product}`}
          title={getI18n('dashboard.reportingDashboardcommon.tpbqop_title')}
          barTitle={replaceI18nVariables(
            getI18n('dashboard.reportingDashboardcommon.tpbqop_bartitle'),
            currencySymbol,
          )}
          overlayTitle={getI18n(
            'dashboard.reportingDashboardcommon.tpbqop_title',
          )}
          overlayDescription={getI18n(
            'dashboard.reportingDashboardcommon.tpbqop_overlaydesc',
          )}
        />
        <BarChartItem
          formatAmount={handleFormatAmount}
          data={topDestinationRegionsByPaidOrderAmount}
          title={getI18n('dashboard.reportingDashboardcommon.tdcpoa_title')}
          barTitle={replaceI18nVariables(
            getI18n('dashboard.reportingDashboardcommon.tdcpoa_bartitle'),
            currencySymbol,
          )}
          overlayTitle={getI18n(
            'dashboard.reportingDashboardcommon.tdcpoa_title',
          )}
          overlayDescription={getI18n(
            'dashboard.reportingDashboardcommon.tdcpoa_overlaydesc',
          )}
        />
        <BarChartItem
          formatAmount={handleFormatAmount}
          data={topDestinationRegionsByNumberOfPaidOrder}
          title={getI18n('dashboard.reportingDashboardcommon.tdcnpo_title')}
          barTitle={getI18n(
            'dashboard.reportingDashboardcommon.tdcnpo_bartitle',
          )}
          overlayTitle={getI18n(
            'dashboard.reportingDashboardcommon.tdcnpo_title',
          )}
          overlayDescription={getI18n(
            'dashboard.reportingDashboardcommon.tdcnpo_overlaydesc',
          )}
        />
        <BarChartItem
          formatAmount={handleFormatAmount}
          data={paidOrderAmountByLogisticsMethod}
          title={getI18n('dashboard.reportingDashboardcommon.poalm_title')}
          barTitle={replaceI18nVariables(
            getI18n('dashboard.reportingDashboardcommon.poalm_bartitle'),
            currencySymbol,
          )}
          overlayTitle={getI18n(
            'dashboard.reportingDashboardcommon.poalm_title',
          )}
          overlayDescription={getI18n(
            'dashboard.reportingDashboardcommon.poalm_overlaydesc',
          )}
        />
        <BarChartItem
          formatAmount={handleFormatAmount}
          data={numberOfPaidOrderByLogisticsMethod}
          title={getI18n('dashboard.reportingDashboardcommon.nopolm_title')}
          barTitle={getI18n(
            'dashboard.reportingDashboardcommon.nopolm_bartitle',
          )}
          overlayTitle={getI18n(
            'dashboard.reportingDashboardcommon.nopolm_title',
          )}
          overlayDescription={getI18n(
            'dashboard.reportingDashboardcommon.nopolm_overlaydesc',
          )}
        />
      </div>
    </Skeleton>
  ) : (
    <NoPermission
      title={getI18n('dashboard.reportingDashboardcommon.noPermission_title')}
      subTitle={getI18n(
        'dashboard.reportingDashboardcommon.noPermission_subtitle',
      )}
    />
  );
};

export default ReportingDashboard;
